import React from 'react'

const DatenschutzPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-3xl font-bold mb-8 text-center">Datenschutzerklärung</h1>
        
        <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
          <div>
            <h2 className="text-2xl font-semibold mb-4">1. Datenschutz auf einen Blick</h2>
            
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-semibold mb-2">Allgemeine Hinweise</h3>
                <p className="text-gray-700">
                  Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, 
                  wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert 
                  werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten 
                  Datenschutzerklärung.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg font-semibold mb-2">Datenerfassung auf dieser Website</h3>
                
                <div className="space-y-3">
                  <div>
                    <h4 className="font-semibold">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
                    <p className="text-gray-700">
                      Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie 
                      dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
                    </p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold">Wie erfassen wir Ihre Daten?</h4>
                    <p className="text-gray-700">
                      Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten 
                      handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch oder nach Ihrer Einwilligung 
                      beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, 
                      Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese 
                      Website betreten.
                    </p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold">Wofür nutzen wir Ihre Daten?</h4>
                    <p className="text-gray-700">
                      Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten 
                      können zur Analyse Ihres Nutzerverhaltens verwendet werden.
                    </p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold">Welche Rechte haben Sie bezüglich Ihrer Daten?</h4>
                    <p className="text-gray-700">
                      Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten 
                      personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten 
                      zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung 
                      jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung 
                      der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei 
                      der zuständigen Aufsichtsbehörde zu.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t pt-6">
            <h2 className="text-2xl font-semibold mb-4">2. Hosting</h2>
            <p className="text-gray-700 mb-4">
              Wir hosten die Inhalte unserer Website bei folgenden Anbietern:
            </p>
            
            <div className="space-y-4">
              <div className="bg-blue-50 p-4 rounded border border-blue-200">
                <h3 className="font-semibold mb-2 text-blue-800">Frontend-Hosting: Vercel</h3>
                <p className="text-gray-700 text-sm mb-2">
                  Die Website-Oberfläche wird von Vercel Inc. gehostet:
                </p>
                <div className="text-sm text-gray-600">
                  <p><strong>Vercel Inc.</strong></p>
                  <p>340 S Lemon Ave #4133</p>
                  <p>Walnut, CA 91789, USA</p>
                  <p className="mt-2">
                    <strong>Datenschutzerklärung:</strong> 
                    <a href="https://vercel.com/legal/privacy-policy" className="text-blue-600 hover:underline ml-1" target="_blank" rel="noopener noreferrer">
                      https://vercel.com/legal/privacy-policy
                    </a>
                  </p>
                </div>
              </div>
              
              <div className="bg-indigo-50 p-4 rounded border border-indigo-200">
                <h3 className="font-semibold mb-2 text-indigo-800">Backend-Hosting: Railway</h3>
                <p className="text-gray-700 text-sm mb-2">
                  Die Server-Anwendung und API werden von Railway Corp. gehostet:
                </p>
                <div className="text-sm text-gray-600">
                  <p><strong>Railway Corp.</strong></p>
                  <p>2261 Market Street #4008</p>
                  <p>San Francisco, CA 94114, USA</p>
                  <p className="mt-2">
                    <strong>Datenschutzerklärung:</strong> 
                    <a href="https://railway.app/legal/privacy" className="text-indigo-600 hover:underline ml-1" target="_blank" rel="noopener noreferrer">
                      https://railway.app/legal/privacy
                    </a>
                  </p>
                </div>
              </div>
              
              <div className="bg-green-50 p-4 rounded border border-green-200">
                <h3 className="font-semibold mb-2 text-green-800">Datenbank-Hosting: MongoDB Atlas</h3>
                <p className="text-gray-700 text-sm mb-2">
                  Die Datenbank wird von MongoDB Inc. in der EU gehostet:
                </p>
                <div className="text-sm text-gray-600">
                  <p><strong>MongoDB Inc.</strong></p>
                  <p>1633 Broadway, 38th Floor</p>
                  <p>New York, NY 10019, USA</p>
                  <p><strong>Server-Standort:</strong> Europa (Frankfurt, Deutschland)</p>
                  <p className="mt-2">
                    <strong>Datenschutzerklärung:</strong> 
                    <a href="https://www.mongodb.com/legal/privacy-policy" className="text-green-600 hover:underline ml-1" target="_blank" rel="noopener noreferrer">
                      https://www.mongodb.com/legal/privacy-policy
                    </a>
                  </p>
                </div>
              </div>
            </div>
            
            <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded">
              <p className="text-sm text-gray-700">
                <strong>Rechtsgrundlage:</strong> Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen 
                und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten Bereitstellung 
                unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
              </p>
            </div>
          </div>
          
          <div className="border-t pt-6">
            <h2 className="text-2xl font-semibold mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>
            
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-semibold mb-2">Datenschutz</h3>
                <p className="text-gray-700">
                  Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre 
                  personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzbestimmungen sowie dieser 
                  Datenschutzerklärung.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg font-semibold mb-2">Hinweis zur verantwortlichen Stelle</h3>
                <p className="text-gray-700 mb-2">Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
                <div className="bg-gray-50 p-4 rounded">
                  <p><strong>PhoneMedic</strong></p>
                  <p>Konrad Blersch</p>
                  <p>Wahlenstraße 27</p>
                  <p>93047 Regensburg</p>
                  <p className="mt-2">
                    <strong>Telefon:</strong> +49 (0) 160 5010907<br />
                    <strong>E-Mail:</strong> service@phone-medic.de
                  </p>
                </div>
                <p className="text-gray-700 mt-2">
                  Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über 
                  die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg font-semibold mb-2">Speicherdauer</h3>
                <p className="text-gray-700">
                  Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre 
                  personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes 
                  Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, 
                  sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten haben 
                  (z. B. steuer- oder handelsrechtliche Aufbewahrungsfristen).
                </p>
              </div>
              
              <div>
                <h3 className="text-lg font-semibold mb-2">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
                <p className="text-gray-700">
                  Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits 
                  erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung 
                  bleibt vom Widerruf unberührt.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg font-semibold mb-2">SSL- bzw. TLS-Verschlüsselung</h3>
                <p className="text-gray-700">
                  Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel 
                  Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine 
                  verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" 
                  wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
                </p>
              </div>
            </div>
          </div>
          
          <div className="border-t pt-6">
            <h2 className="text-2xl font-semibold mb-4">4. Datenerfassung auf dieser Website</h2>
            
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-semibold mb-2">Cookies</h3>
                <p className="text-gray-700">
                  Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Textdateien und richten auf Ihrem 
                  Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) 
                  oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden nach Ende Ihres 
                  Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst 
                  löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg font-semibold mb-2">Kontaktformular</h3>
                <p className="text-gray-700">
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive 
                  der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen 
                  bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg font-semibold mb-2">Anfrage per E-Mail, Telefon oder Telefax</h3>
                <p className="text-gray-700">
                  Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden 
                  personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. 
                  Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                </p>
              </div>
            </div>
          </div>
          
          <div className="border-t pt-6">
            <h2 className="text-2xl font-semibold mb-4">5. Zahlungsdienstleister</h2>
            
            <div className="space-y-4">
              <div className="bg-blue-50 p-4 rounded border border-blue-200">
                <h3 className="font-semibold mb-2 text-blue-800">PayPal</h3>
                <p className="text-gray-700 text-sm mb-2">
                  Auf dieser Website bieten wir u.a. die Bezahlung via PayPal an. Anbieter dieses Zahlungsdienstleisters ist die PayPal (Europe) S.à r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg (im Folgenden „PayPal").
                </p>
                <p className="text-gray-700 text-sm mb-2">
                  Wenn Sie die Bezahlung via PayPal auswählen, werden die von Ihnen eingegebenen Zahlungsdaten an PayPal übermittelt.
                </p>
                <div className="text-sm text-gray-600">
                  <p><strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) und Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</p>
                  <p className="mt-2">
                    <strong>Datenschutzerklärung:</strong> 
                    <a href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full" className="text-blue-600 hover:underline ml-1" target="_blank" rel="noopener noreferrer">
                      https://www.paypal.com/de/webapps/mpp/ua/privacy-full
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t pt-6">
            <h2 className="text-2xl font-semibold mb-4">6. Plugins und Tools</h2>
            <p className="text-gray-700">
              Diese Website nutzt verschiedene Plugins und Tools zur Verbesserung der Funktionalität. Informationen über die 
              jeweiligen Anbieter und deren Datenschutzbestimmungen finden Sie in den entsprechenden Abschnitten.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DatenschutzPage